<template>
  <div
    class="item-box-430 settlement-details-table"
    :class="{ downloadSettlement: download }"
  >

    <Table
      :max-height="download ? '-' : '550'"
      :border="!download"
      :loading="loading"
      :columns="tableColumnsShow"
      :data="tableData"
      :row-class-name="rowClassName"
      @on-selection-change="onSelectionChange"
    >
      <template slot="number" slot-scope="{ row, index }">
        <div v-if="download" class="num-tag">
          {{ row.number }}
        </div>
        <div v-else class="num-tag">
          <div v-if="row.tag&&row.tag===1&&row.orgName != '合计'" class="triangle"></div>
          {{ row.number }}
        </div>
      </template>
      <template slot="orgCheck" slot-scope="{ row, index }">
        <span :class="getOrgCheckClass(row.orgCheck)">{{
          row.orgCheck | initOrgCheck
        }}</span>
      </template>

      <template slot="payeeCheck" slot-scope="{ row, index }">
        <span :class="getOrgCheckClass(row.orgCheck)">{{
          row.payeeCheck | initPayeeCheck
        }}</span>
      </template>

      <!-- <template slot="unionCheck" slot-scope="{ row, index }">
        <span
          :class="getUnionCheckClass(row.unionCheck)"
          @click="handleToDetails(row, index, 1)"
          >{{ row.unionCheck | initUnionCheck }}</span
        >
      </template>
      <template slot="eduCheck" slot-scope="{ row, index }">
        <span
          :class="getEduCheckClass(row.eduCheck)"
          @click="handleToDetails(row, index, 2)"
          >{{ row.eduCheck | initEduCheck }}</span
        >
      </template> -->

      <template
        slot="approvalEduSts"
        slot-scope="{ row, index }"
      >
        <span v-if="row.orgName != '合计' && row.orgName != '当前页面小计'" :class="getEduCheckClass(row.approvalSts)" @click="handleToDetails(row, index, 1)">{{
          row.approvalSts | initApprovalEduSts
        }}</span>
      </template>

      <template slot="settleSts" slot-scope="{ row, index }">
        <span v-if="row.orgName != '合计' && row.orgName != '当前页面小计'">{{
          row.settleSts | initSettleSts
        }}</span>
      </template>

      <template slot="approvalSts" slot-scope="{ row, index }">
        <span v-if="row.orgName != '合计'" class="sts-dot" :class="appColor[row.approvalSts]">{{
          row.approvalSts | initApprovalSts
        }}</span>
      </template>

      <template slot="action" slot-scope="{ row, index }">
        <Button
          v-if="row.orgName != '合计'&&row.orgName != '当前页面小计'"
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="handleToDetails(row, index, 0)"
        >查看详情</Button>
      </template>
      <template slot="actionList" slot-scope="{ row, index }">
        <Button
          v-if="row.orgName != '合计'||billPlatfromMode==='3' || tableType==2"
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="handleToList(row, index, 0)"
        >{{ tableType == 2 && portOrg == 2&&row.orgName != '合计' ?'查看详情':'查看明细' }}</Button>
      </template>
    </Table>
    <Modal
      v-model="showActionModal"
      :closable="false"
      @on-ok="handleOk"
      @on-cancel="handleCancel"
    >
      <div style="padding: 20px 0">
        <Checkbox v-model="single">展示所有其他分账方列</Checkbox>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getColumn, merchantCommission, sendThis, selectionColumn } from '../data/SettlementDetailsTable';
import { getSearchsStorage, setSearchsStorage } from '@/utils/storage';
import { mapState, mapActions } from 'vuex';
import { getApprovalSts } from '../data/utils';
import { getYearMonthDate } from '@/utils/utils';
export default {
  inject: ['detailsData', 'tableType'],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    download: {
      type: Boolean,
      default: false
    },
    titleStr: {
      type: String,
      default: ''
    },
    eduAreaCode: {
      type: String,
      default: ''
    },
    index: {
      type: [String, Number],
      default: 0
    },
    ApprovalModeId: {
      type: String,
      default: ''
    },
    billPlatfromMode: {
      type: String,
      default: '1'
    }

  },
  data() {
    return {
      // tableType: 1: 运营平台 - 机构端->机构 2:运营平台 - 学校端 ->学校 3:教育局
      tableColumns: [],
      portOrg: localStorage.getItem('portOrg'),
      tablePortOrg: this.$route.meta.tablePortOrg,
      showActionModal: false,
      single: false,
      selectionRows: [],
      appColor: {
        0: 'red',
        1: 'orange',
        2: 'yellow',
        3: 'green',
        4: 'blue',
        5: 'purple',
        99: 'gray'
      }
    };
  },

  computed: {
    ...mapState({
      settlementConfig: state => state.orderCenter.settlementConfig,
      isTrueTally: state => state.orderCenter.isTrueTally,
      userInfo: state => state.userInfo
    }),
    beginMonth() {
      // const day = this.detailsData.settleMonth.split('-');
      // return `${day[1]}月`;

      const { beginTime, endTime } = this.detailsData;
      const { year: beginYear, month: beginMonth } = getYearMonthDate(beginTime);
      const { year: endYear, month: endMonth } = getYearMonthDate(endTime);
      if (!endYear || !endMonth) {
        return `${beginMonth}月`;
      } else if (beginYear === endYear && beginMonth === endMonth) {
        return `${beginMonth}月`;
      } else if (beginYear === endYear) {
        return `${beginMonth}-${endMonth}月`;
      } else {
        return `${beginMonth}-${endMonth}月`;
      }
    },
    beginTime() {
      const day = this.detailsData.beginTime.split('-');
      return `${day[0]}年${day[1]}月`;
    },
    // settleMonth() {
    //   const { beginTime, endTime } = this.detailsData;
    //   const { year: beginYear, month: beginMonth } = getYearMonthDate(beginTime);
    //   const { year: endYear, month: endMonth } = getYearMonthDate(endTime);
    //   if (!endYear || !endMonth) {
    //     return `${beginYear}年${beginMonth}月`;
    //   } else if (beginYear === endYear && beginMonth === endMonth) {
    //     return `${beginYear}年${beginMonth}月`;
    //   } else if (beginYear === endYear) {
    //     return `${beginYear}年${beginMonth}~${endMonth}月`;
    //   } else {
    //     return `${beginYear}年${beginMonth}月~${endYear}年${endMonth}月`;
    //   }
    // },
    // 是否有权限审核
    userIsUnionCheck() {
      const arr = this.settlementConfig.filter(item => { return item.codeType == 'STATEMENT_SHEET@FIRST_CHEKER'; });
      if (arr.length) {
        for (const val of arr[0]['users']) {
          console.log(val.userId, this.userInfo.id);
          if (val.userId == this.userInfo.id) {
            return true;
          }
        }
      }
      return false;
    },
    // 是否有权限 教育局复审
    userIsEduCheck() {
      const arr = this.settlementConfig.filter(item => { return item.codeType == 'STATEMENT_SHEET@SECOND_CHEKER'; });
      if (arr.length) {
        for (const val of arr[0]['users']) {
          if (val.userId == this.userInfo.id) {
            return true;
          }
        }
      }
      return false;
    },
    // 是否是 2022年8月份以后
    isNinthMonth() {
      const day = this.detailsData.beginTime.split('-');
      const dayNum = String(day[0]) + String(day[1]);
      return Number(dayNum) > 202208;
    },
    // 是否是 2023年8月份以后
    is23NinthMonth() {
      const day = this.detailsData.beginTime.split('-');
      const dayNum = String(day[0]) + String(day[1]);
      return Number(dayNum) > 202308;
    },
    // 是否是 2023年2月份以前
    isHideWxAmt() {
      const day = this.detailsData.beginTime.split('-');
      const dayNum = String(day[0]) + String(day[1]);
      return Number(dayNum) < 202302;
    },
    tableColumnsShow() {
      let list = [];
      if (this.tableType == 1 && this.billPlatfromMode === '1') {
        this.tableColumns.forEach(item => {
          if (item.key !== 'totalChannelAmt') {
            list.push(item);
          }
        });
      } else if (this.tableType == 1 && this.billPlatfromMode === '2') {
        this.tableColumns.forEach(item => {
          if (item.key !== 'totalChannelAmt' && item.key !== 'platServiceFee' && item.key !== 'totalDivideAmt') {
            list.push(item);
          }
        });
      } else if (this.tableType == 1 && this.billPlatfromMode === '3' && !this.download) {
        this.tableColumns.forEach(item => {
          if (item.key !== 'totalChannelAmt') {
            list.push(item);
          }
        });
        list.splice(0, 1,
          {
            title: '序号',
            slot: 'number',
            width: 120,
            align: 'center',
            fixed: 'left',
            className: 'number-block'
          });
        list.splice(-1, 1,
          {
            title: '操作',
            slot: 'actionList',
            minWidth: 120,
            align: 'center',
            fixed: 'right'
          });
      } else if (this.tableType == 1 && this.billPlatfromMode === '3' && this.download) {
        this.tableColumns.forEach(item => {
          if (item.key !== 'totalChannelAmt') {
            list.push(item);
          }
        });
      } else if (this.tableType == 2 && this.download) {
        this.tableColumns.forEach(item => {
          if (item.title !== '对账状态') {
            list.push(item);
          }
        });
      } else {
        list = this.tableColumns.map(item => {
          return item;
        });
      }

      return list;
    }
  },
  watch: {
    tableData: {
      handler: function(newVal, oldVal) {
        this.actionOtherSubTableColumn();
      },
      deep: true
    },
    ApprovalModeId(newVal, oldVal) {
      if (newVal == '210001' && this.tableType == 3) {
        //  this.handleEduColumns();
      }
    }
  },

  created() {
    sendThis(this);
    this.initColumn();
  },
  methods: {
    ...mapActions('orderCenter', [
      'udpateNodeEnum'
    ]),
    rowClassName(row, index) {
      if (row.itemType === 'all') {
        return 'demo-table-info-row';
      }
      return '';
    },
    // handleEduColumns() {
    //   this.tableColumns.splice(4, 2, {
    //     title: '收款单位审批',
    //     slot: `payeeCheck`,
    //     align: 'center',
    //     width: 120
    //   });
    // },
    // 初始化表头
    initColumn() {
      if (this.$route.meta.tableType == 3) {
        // 表格类型三：教育局审批单
        // 运营端 教育局审批单
        // if (this.portOrg == 0) {
        this.tableColumns = getColumn(this.$route.meta.tableType, {
          type: 4,
          bankId: this.detailsData.data.bankId,
          children: [{
            title: 'Other',
            key: 1,
            value: this.beginMonth
          }]
        });
      } else {
        let opt;
        // 非教育局端：
        if (!this.download) {
          opt = {
            type: 2,
            bankId: this.detailsData.data.bankId
          };
        } else {
          opt = {
            type: 3,
            bankId: this.detailsData.data.bankId
          };
        }
        // && this.tablePortOrg != 'edu'
        // 4: 运营端或者教育局端 机构结算单
        const tableType = ((this.portOrg == 0 || this.portOrg == 1) && this.$route.meta.tableType == 1) ? 4 : this.$route.meta.tableType;
        this.tableColumns = getColumn(tableType, opt);
        // 教育局 机构结算单 隐藏手续费
        // if (this.portOrg == 1 && this.isHideWxAmt) {
        //   let key = this.tableColumns.findIndex(item => { return item.title == '手续费' })
        //   if (key != -1) {
        //     this.tableColumns.splice(key, 1)
        //   }
        // }
        if (this.tableType == 2 && this.portOrg == 2) {
          const key = this.tableColumns.findIndex(item => item.key === 'platAmt');
          // key !== -1 ? this.tableColumns = this.tableColumns.toSpliced(key, 1) : '';
          const tableColumns = JSON.parse(JSON.stringify(this.tableColumns));
          tableColumns.splice(key, 1);
          this.tableColumns = tableColumns;
        }

        // 学校端、 学校确认单增加表格多选框
        if (!this.download && this.portOrg == 2 && this.$route.meta.tableType == 2) {
          this.tableColumns = [...selectionColumn, ...this.tableColumns];
        }
      }
    },
    actionOtherSubTableColumn() {
      if (this.tableType == 2) {
        return null;
      }
      if (this.tableData.length > 0) {
        const single = getSearchsStorage('settlementActionShow');

        if (single && this.billPlatfromMode !== '3') {
          this.showOtherSubTableColumn();
        } else {
          this.hideOtherSubTableColumn();
        }
      }
    },
    getOtherOrgs(checkList) {
      const map = {};
      this.tableData.forEach(item => {
        item.otherSubLedgerParties.forEach(item_1 => {
          if (!map[item_1.orgId] && checkList.findIndex(item => { return item.key == ('otherOrgName' + item_1.orgId); }) == -1) {
            map[item_1.orgId] = {
              orgId: item_1.orgId,
              orgName: item_1.orgName
            };
          }
        });
      });
      const arr = [];
      for (const k in map) {
        arr.push(map[k]);
      }
      return arr;
    },

    getHideOtherOrgs(checkList) {
      const map = {};
      this.tableData.forEach(item => {
        item.otherSubLedgerParties.forEach(item_1 => {
          if (!map[item_1.orgId]) {
            map[item_1.orgId] = {
              orgId: item_1.orgId,
              orgName: item_1.orgName
            };
          }
        });
      });
      const arr = [];
      for (const k in map) {
        arr.push(map[k]);
      }
      return arr;
    },
    showOtherSubTableColumn() {
      const key = this.tableColumns.findIndex(item => { return item.key && item.key.indexOf('otherOrgName') > -1; });
      if (key != -1) {
        return null;
      }
      let arr = [];
      if (this.tableType == 3) {
        arr = this.getOtherOrgs(this.tableColumns[2].children);
      } else {
        arr = this.tableData[0]['otherSubLedgerParties'];
      }

      const data = [];
      arr && arr.forEach((item, index) => {
        data.push({
          title: item.orgName,
          key: `otherOrgName` + (item.orgId),
          width: 180,
          align: 'center'
        });
      });
      if (this.tableType == 3) {
        this.tableColumns[2].children.splice(8, 0, ...data);
      } else {
        this.tableColumns.splice(10, 0, ...data);
      }
    },
    hideOtherSubTableColumn() {
      const key = this.tableColumns.findIndex(item => { return item.key && item.key.indexOf('otherOrgName') > -1; });
      let arr = [];
      if (this.tableType == 3) {
        arr = this.getHideOtherOrgs(this.tableColumns[2].children);
      } else {
        arr = this.tableData[0]['otherSubLedgerParties'];
      }
      if (this.tableType == 3 && this.tableColumns[2].children.length != 9) {
        this.tableColumns[2].children.splice(8, arr.length);
      } else {
        if (key != -1) {
          this.tableColumns.splice(10, arr.length,);
        }
      }
      console.log(this.tableColumns, arr, 'tableColumnstableColumns');
    },
    onSelectionChange(rows) {
      this.selectionRows = rows;
      this.$emit('on-selectionTable', this.selectionRows);
    },
    // 获取机构审核 样式
    getOrgCheckClass(status) {
      // if (status == 5) {
      //   return 'warn'
      // }
      if (status > 2) {
        return 'confirm';
      }
    },
    // 获取协会审批样式
    getUnionCheckClass(status) {
      if (status > 4) {
        return 'confirm';
      }
      // if ([6].includes(status)) {
      //   return this.userIsUnionCheck ? 'isCheck warn' : 'warn'
      // }
      if ([4].includes(status)) {
        return this.userIsUnionCheck ? 'isCheck unCheck' : 'unCheck';
      }
    }, // 获取教育局审核 样式
    // getEduCheckClass(status) {
    //   if (status > 5) {
    //     return 'confirm';
    //   }
    //   // if ([7].includes(status)) {
    //   //   return this.userIsEduCheck ? 'isCheck warn' : 'warn'
    //   // }
    //   if ([5].includes(status)) {
    //     return this.userIsEduCheck ? 'isCheck unCheck' : 'unCheck';
    //   }
    // },
    // 获取审批样式
    getEduCheckClass(status) {
      if (status > 5) {
        return 'confirm';
      }
      // if ([7].includes(status)) {
      //   return this.userIsEduCheck ? 'isCheck warn' : 'warn'
      // }
      if ([4].includes(status)) {
        return this.userIsEduCheck ? 'isCheck unCheck' : 'unCheck';
      }
      if ([5].includes(status)) {
        return this.userIsEduCheck ? 'isCheck unCheck' : 'unCheck';
      }
      return '';
    },
    // 跳转详情
    handleToDetails(row, index, nodeEnum) {
      // const map = {
      //   4: this.getUnionCheckClass(row.unionCheck),
      //   5: this.getEduCheckClass(row.eduCheck)
      // };

      const detailsData = JSON.parse(JSON.stringify(this.detailsData));
      // 判断非详情页跳转是否有权限
      if (nodeEnum != 0 && (this.getEduCheckClass(row.approvalSts).indexOf('isCheck') === -1)) {
        return null;
      }

      if (!detailsData.data.orgId) {
        detailsData.data.orgId = row.orgId;
        detailsData.data.orgName = row.orgName;
      }
      // 教育局端
      if (this.portOrg == 1) {
        detailsData.data.orgId = row.orgId;
        detailsData.data.orgName = row.orgName;
      }
      detailsData.tableType = 1;
      // detailsData.statementId = row.statementId
      detailsData.approvalSts = row.approvalSts;
      detailsData.sheetId = row.sheetId;
      detailsData.settlementSheetOrgName = row.settlementSheetOrgName;
      this.udpateNodeEnum(nodeEnum);

      this.$router.push({
        name: 'financeCenter_settlement_edu_orgdetails',
        query: {
          detailsData: encodeURIComponent(JSON.stringify(detailsData)),
          // statementId: row.statementId,
          nodeEnum: nodeEnum

        }
      });

      // const routeUrl = this.$router.resolve({
      //   name: 'financeCenter_settlement_edu_orgdetails',
      //   query: {
      //     detailsData: encodeURIComponent(JSON.stringify(detailsData)),
      //     // statementId: row.statementId,
      //     nodeEnum: nodeEnum

      //   }
      // });

      // window.open(routeUrl.href, '_blank');
    },
    handleRoute(urlName, row) {
      console.log('row----', this.detailsData.sheetId, this.beginMonth, row, this.tableType, this.detailsData);
      this.$router.push({
        name: urlName,
        query: {
          sheetId: (row.itemType == 'all' && this.tableType == 2) ? this.tableData[0].sheetId : this.detailsData.sheetId ? this.detailsData.sheetId : row.sheetId,
          titleStr: this.titleStr,
          beginTime: this.beginTime,
          // settleMonth: this.settleMonth,
          isTrueTally: this.isNinthMonth ? 1 : this.isTrueTally,
          isNinthMonth: this.isNinthMonth,
          tableType: this.tableType,
          eduAreaCode: this.eduAreaCode,
          // beginMonth: this.beginMonth,
          bankId: this.detailsData.bankId,
          bankType: this.detailsData.bankType,
          orgName: row.itemType == 'all' ? '' : (row.orgName ? row.orgName : this.detailsData.data.orgName),
          schId: this.getSchId(row),
          orgId: this.getOrgId(row),
          orgIds: (row.itemType == 'all' && this.tableType == 2) ? this.getOrgIds() : '',
          statementId: this.tableType == 2 ? (row.itemType == 'all' ? this.detailsData.statementId : row.statementId) : this.detailsData.statementId,
          statementIds: ((this.billPlatfromMode === '3' || this.tableType == 2) && row.orgName === '合计') ? this.getAllMainSettlementSheetId() : this.getStatementIds(row),
          sheetIds: ((this.billPlatfromMode === '3' || this.tableType == 2) && row.orgName === '合计') ? this.getSheetIds() : '',
          noShowOtherColumns: this.billPlatfromMode === '3' || this.tableType == 2 ? 1 : 0,
          sheetBeginTime: row.beginTime ? row.beginTime : this.detailsData.beginTime,
          sheetEndTime: row.endTime ? row.endTime : this.detailsData.endTime
        }
      });
    },
    getSheetIds() {
      const sheetIds = this.tableData.filter(item => {
        return item.orgName != '合计';
      }).map(item => {
        return item.sheetId;
      });
      return sheetIds.join(',');
    },
    getOrgIds() {
      const orgIds = this.tableData.filter(item => {
        return item.orgName != '合计';
      }).map(item => {
        return item.orgId;
      });
      return orgIds.join(',');
    },
    getAllMainSettlementSheetId() {
      const mainSettlementSheetIds = this.tableData.filter(item => {
        return item.orgName != '合计';
      }).map(item => {
        return item.mainSettlementSheetId;
      });
      console.log(mainSettlementSheetIds, '拿到的数据是------getAllMainSettlementSheetId');
      return mainSettlementSheetIds.join(',');
    },
    getStatementIds(row) {
      console.log(this.tableData, 'this.tableData');
      const statementIds = [];
      if (this.tableType == 2 && row.itemType == 'all') {
        this.tableData.forEach(item => {
          if (item.itemType != 'all') {
            item.statementId && statementIds.push(item.statementId);
          }
        });
      }
      return this.tableType == 2 && row.itemType == 'all' ? statementIds.join(',') : '';
    },
    // 获取学校id
    getSchId(row) {
      let schId = '';
      if (this.tableType == 1) {
        schId = row.itemType == 'all' ? '' : row.schoolId;
      } else if (this.tableType == 2) {
        schId = this.detailsData.data.schId;
      }
      return schId;
    },
    // 获取机构id
    getOrgId(row) {
      let orgId = '';
      if (this.tableType == 1) {
        orgId = this.detailsData.data.orgId;
      } else if (this.tableType == 2) {
        orgId = row.itemType == 'all' ? '' : row.orgId;
      }
      return orgId;
    },
    // 查看明细
    handleToList(row, index) {
      const routeName = this.tableType == 1 ? 'financeCenter_settlement_org_details_list' : 'financeCenter_settlement_sch_details_list';
      // this.handleRoute(routeName, row);
      // return;
      if (this.tableType === 2 && +this.portOrg === 2 && row.orgName != '合计') {
        const data = JSON.parse(JSON.stringify(row));
        data.orgId = row.orgId;
        data.orgName = row.orgName;
        row.schoolId ? data.schId = row.schoolId : '';
        row.schoolName ? data.schName = row.schoolName : '';
        row.bankType ? data.bankId = row.bankType : '';
        const detailsData = encodeURIComponent(JSON.stringify({
          ...row, data: { ... data }, tableType: 1, portOrg: +this.portOrg, isFromSchoolEduSure: 1
        }));
        this.$router.push({
          name: 'financeCenter_settlement_org_detailsForSchoolSure',
          query: { detailsData }
        });
        console.log('这是1232');
      } else {
        this.handleRoute(routeName, row);
      }
    },
    handleShowActionModal() {
      const single = getSearchsStorage('settlementActionShow');
      if (single) {
        this.single = Boolean(single);
      } else {
        this.single = false;
      }
      this.showActionModal = true;
    },
    handleOk() {
      setSearchsStorage(this.single, 'settlementActionShow');
      if (this.tableType != 3) {
        window.location.reload();
      } else {
        this.actionOtherSubTableColumn();
      }

      // this.$emit('on-updateStSHOWOtherCol')
    },
    handleCancel() {

    }
  },
  filters: {
    // 收款单位审批
    initPayeeCheck(val) {
      const str = '待审批';
      if (val === '') {
        return '';
      }
      if (val > 4) {
        return '审批通过  ';
      }
      return str;
    },
    // 机构状态显示
    initOrgCheck(val) {
      const str = '已确认';

      if (val === '') {
        return '';
      }
      if (val < 3) {
        return '待确认';
      }
      // if (val == 0) {
      //   return '待确认'
      // }
      // if (val == 8) {
      //   return '待确认'
      // }
      // if (val == 5) {
      //   return '审批驳回'
      // }
      return str;
    },
    // 协会状态显示
    initUnionCheck(val) {
      const str = '待预审';
      if (val === '') {
        return '';
      }
      // if (val == 6) {
      //   return "驳回"
      // }
      if (val > 4) {
        return '审批通过';
      }
      return str;
    },
    // 教育局状态显示
    initEduCheck(val) {
      const str = '待复审';
      if (val === '') {
        return '';
      }
      // if (val == 7) {
      //   return "审批驳回"
      // }
      if (val > 5) {
        return '审批通过 ';
      }
      return str;
    },
    // 结算状态
    initSettleSts(val) {
      const str = '未结算';
      if (val === '') {
        return '';
      }
      if (val == 1) {
        return '已结算';
      }
      if (val == 2) {
        return '待结算';
      }
      if (val == 3) {
        return '结算中';
      }
      return str;
    },
    initApprovalSts(val) {
      return getApprovalSts(val);
    },
    initApprovalEduSts(val) {
      const str = '待审批';
      if (val == 4) {
        return '待预审';
      }
      if (val == 5) {
        return '待复审';
      }

      if (val == 99) {
        return '审批通过';
      }
      return str;
    }
  }
};
</script>

<style lang="scss" scoped>
.settlement-details-table {
  padding: 0px 30px 30px !important;
  .confirm {
    color: #488ffa;
  }
  .warn {
    color: #ff760d;
  }
  .isCheck {
    text-decoration: underline;
    cursor: pointer;
  }
  .unCheck {
    color: red;
  }
  /deep/ .ivu-table-tbody {
    tr {
      .ivu-table-cell {
        padding: 0 8px;
      }
      // &:last-child {
      //   td {
      //     background-color: #f8f8f9;
      //   }
      // }
    }
  }
   /deep/ .ivu-table .demo-table-info-row{
    background: #f8f8f9;
    td{
        background-color: #f8f8f9;
    }
   }
  /deep/.ivu-table td.number-block{
    .ivu-table-cell,.ivu-table-cell-slot{
      width: 100%;
      height: 100%;
      padding: 0;
      .num-tag{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .triangle {
          width: 0;
          height: 0;
          border-width: 15px ; /* 设置边长 */
          border-style: solid;
          border-color: red transparent transparent red; /* 颜色为红色 */
          position: absolute;
          top: 0;
          left: 0;
        }

        /* 上面的三角形 */
        .triangle::before {
          content: "当前";
          color: #fff;
          position: absolute;
          width: 40px;
          z-index: 100;
          font-size: 14px;
          transform: translate(-65%, -100%) scale(0.55) rotate(-45deg);
        }

      }
    }
  }
}
/* 打印样式 */
.downloadSettlement {
  /deep/ .ivu-table {
    table {
      span {
        display: inline-block;
      }
    }
  }
  /deep/ .ivu-table:before{
    height: 0;
  }
  /deep/.ivu-table-fixed::before,/deep/ .ivu-table-fixed-right::before{
    height: 0;
  }
}
.sts-dot {
  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
}
.red::before {
  background: red;
}
.orange::before {
  background: orange;
}
.yellow::before {
  background: yellow;
}
.green::before {
  background: green;
}
.blue::before {
  background: blue;
}
.purple::before {
  background: purple;
}
.gray::before {
  background: gray;
}
</style>

